(function () {

    // Function that is executed for each product of the upsell
    const productCard = (current_product, productIndex) => {

        var addButton_sidecart_upsell = current_product.querySelector('[data-upsell-product-id]');
        const variantSelector = current_product.querySelector('.upsell-product-variant-selector');

        if (!addButton_sidecart_upsell) {
            console.log('Add to cart button not found.');
            return;
        }

        let selectedVariantId = variantSelector ? variantSelector.options[variantSelector.selectedIndex].getAttribute('data-variant') : null;
        let selectedVariantPrice = variantSelector ? variantSelector.options[variantSelector.selectedIndex].getAttribute('data-variant-price') : null;

        // Initialize the button state based on the initial variant availability
        if (variantSelector && !variantSelector.dataset.eventAssigned) {
            updateButtonState();

            variantSelector.addEventListener('change', function() {
                selectedVariantId = this.options[this.selectedIndex].getAttribute('data-variant');
                selectedVariantPrice = this.options[this.selectedIndex].getAttribute('data-variant-price');

                updateButtonState();
            });

            // Mark the event as assigned
            variantSelector.dataset.eventAssigned = true;
        }

        // Function to update the addButton_sidecart_upsell state
        function updateButtonState() {
            const selectedOption = variantSelector.options[variantSelector.selectedIndex];
            const isAvailable = selectedOption.getAttribute('data-variant-available') === 'true';

            if (isAvailable) {
                addButton_sidecart_upsell.disabled = false;
                addButton_sidecart_upsell.textContent = "ADICIONAR";
            } else {
                addButton_sidecart_upsell.disabled = true;
                addButton_sidecart_upsell.textContent = "NÃO DISPONÍVEL"; 
            }
        }

        // Assign a unique ID based on the product index to ensure we don't add the event more than once
        const uniqueEventKey = `upsellClick${productIndex}`;
        if (!addButton_sidecart_upsell.dataset[uniqueEventKey]) {

            // Define the function of the event
            function handleAddToCart() {
                const selectedOption = variantSelector.options[variantSelector.selectedIndex];
                const isAvailable = selectedOption.getAttribute('data-variant-available') === 'true';

                if (isAvailable && selectedVariantId) {
                    addToCart(selectedVariantId, selectedVariantPrice);
                } else {
                    console.log('Please select a variant before adding to cart.');
                }
            }

            // Add the click event
            addButton_sidecart_upsell.addEventListener('click', handleAddToCart);

            // Check the button as already registered for this event
            addButton_sidecart_upsell.dataset[uniqueEventKey] = true;
        }
    };

    // Function to add the product to the cart
    function addToCart(itemId, itemPrice) {
        jQ.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: itemId
            },
            dataType: 'json',
            success: function(data) {
                jQ.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/cart.json',
                    success: function(cart) {
                        updateUpsellItems();
                        jQ('.navigation__item--cart-count').text(cart.item_count);

                        getCart();

                        var drawerCart = document.querySelector('#drawer-cart');
                        drawerCart.dispatchEvent(
                            new CustomEvent('product:addToCart', {
                                detail: {
                                    'productID': itemId,
                                    'productPrice': itemPrice
                                }
                            })
                        );

                        drawerCart.dispatchEvent(
                            new CustomEvent('product:added', {
                                detail: {}
                            })
                        );
                    }
                });
            }
        });
    }

    // Make updateUpsellItems globally accessible
    window.updateUpsellItems = function() {
        jQ.ajax({
            url: '/cart',
            dataType: 'html',
            success: function(data) {
                var newUpsellContent = jQ(data).find('.drawer_cart_upsell').html();
                jQ('.drawer_cart_upsell').html(newUpsellContent);

                productSlider(); // Reset Flickity

                // Re-link the "Add to Cart" events for each upsell product
                var upsellProducts = document.querySelectorAll('.drawer_cart_upsell .product-slider__item__upsell');
                upsellProducts.forEach(function(current_product, index) {
                    productCard(current_product, index);
                });
            },
            error: function() {
                console.error('Error al recargar el upsell.');
            }
        });
    };

    // Run for all upsell products on page load
    window.addEventListener('load', function () {
        var upsellProducts = document.querySelectorAll('.drawer_cart_upsell .product-slider__item__upsell');

        upsellProducts.forEach(function(current_product, index) {
            productCard(current_product, index);
        });
    });

})();
